import {
    CARMENS_OWN_DT_LOG_CREATE,
    CARMENS_OWN_DT_LOG_CREATE_FAIL,
    CARMENS_OWN_DT_LOG_CREATE_SUCCESS,
    DELETE_CARMENS_OWN_DT_LOG,
    DELETE_CARMENS_OWN_DT_LOG_FAIL,
    DELETE_CARMENS_OWN_DT_LOG_SUCCESS,
    GET_CARMENS_OWN_DT_LOG_DETAILS,
    GET_CARMENS_OWN_DT_LOG_DETAILS_FAIL,
    GET_CARMENS_OWN_DT_LOG_DETAILS_SUCCESS,
    RESET,
    RESET_CARMENS_OWN_DT_LOG_CREATE,
    RESET_CARMENS_OWN_DT_LOG_DELETE,
    RESET_CARMENS_OWN_DT_LOG_DETAILS,
    UPDATE_CARMENS_OWN_DT_LOG,
    UPDATE_CARMENS_OWN_DT_LOG_FAIL,
    UPDATE_CARMENS_OWN_DT_LOG_SUCCESS,
} from "./actionsTypes";

const initialState = {
    carmensOwnDTLogList: [],
    carmensOwnDTLogDetails: [],
    createResult: {},
    loading: false,
    detailsLoading: false,
    loadingCreate: false,
    deleteResult: {},
    error: {
        message: "",
    },
};

const CarmensOwnDTLogReducer = (state = initialState, action) => {
    if (!action) return state;

    switch (action.type) {
        case CARMENS_OWN_DT_LOG_CREATE:
            state = { ...state, createResult: {}, loadingCreate: true };
            break;
        case CARMENS_OWN_DT_LOG_CREATE_SUCCESS:
            state = { ...state, createResult: action.payload, loadingCreate: false };
            break;
        case CARMENS_OWN_DT_LOG_CREATE_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                createResult: {},
                loadingCreate: false,
            };
            break;

        case GET_CARMENS_OWN_DT_LOG_DETAILS:
            state = { ...state, detailsLoading: true, carmensOwnDTLogDetails: {} };
            break;
        case GET_CARMENS_OWN_DT_LOG_DETAILS_SUCCESS:
            state = { ...state, carmensOwnDTLogDetails: action.payload, detailsLoading: false };
            break;
        case GET_CARMENS_OWN_DT_LOG_DETAILS_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                detailsLoading: false,
            };
            break;

        case UPDATE_CARMENS_OWN_DT_LOG:
            state = { ...state, createResult: {}, loading: true };
            break;
        case UPDATE_CARMENS_OWN_DT_LOG_SUCCESS:
            state = { ...state, createResult: action.payload, loading: false };
            break;
        case UPDATE_CARMENS_OWN_DT_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
            };
            break;

        case DELETE_CARMENS_OWN_DT_LOG:
            state = { ...state, deleteResult: {}, loading: true, };
            break;
        case DELETE_CARMENS_OWN_DT_LOG_SUCCESS:
            state = { ...state, deleteResult: action.payload, loading: false };
            break;
        case DELETE_CARMENS_OWN_DT_LOG_FAIL:
            state = {
                ...state,
                error: {
                    message: "Error",
                },
                loading: false,
                deleteResult: {}
            };
            break;
        case RESET_CARMENS_OWN_DT_LOG_DETAILS:
            state = { ...state, carmensOwnDTLogDetails: {}, detailsLoading: false };
            break;

        case RESET:
            state = { ...state, carmensOwnDTLogList: [], createResult: {} };
            break;
        case RESET_CARMENS_OWN_DT_LOG_CREATE:
            state = { ...state, createResult: {} };
            break;
        case RESET_CARMENS_OWN_DT_LOG_DELETE:
            state = { ...state, deleteResult: {} };
            break;
        default:
            state = { ...state };
            break;
    }
    return state;
};

export default CarmensOwnDTLogReducer;